<template>
  <vl-properties-list>
    <vl-properties-label>{{ $t('deliveryentity.detail.id') }}</vl-properties-label>
    <vl-properties-data>{{ detail.id }}</vl-properties-data>
    <vl-properties-label>{{ $t('deliveryentity.detail.code') }}</vl-properties-label>
    <vl-properties-data>{{ detail.code }}</vl-properties-data>
    <vl-properties-label>{{ $t('deliveryentity.detail.label') }}</vl-properties-label>
    <vl-properties-data>{{ detail.label }}</vl-properties-data>
    <vl-properties-label>{{ $t('deliveryentity.detail.description') }}</vl-properties-label>
    <vl-properties-data>{{ detail.description }}</vl-properties-data>
    <vl-properties-label>{{ $t('deliveryentity.detail.format') }}</vl-properties-label>
    <vl-properties-data>{{ detail.format.code }} ({{ detail.format.name }})</vl-properties-data>
    <vl-properties-label>{{ $t('deliveryentity.detail.model') }}</vl-properties-label>
    <vl-properties-data><PbsEntityRouterLink type="entityModel" :detail="detail.model" /> </vl-properties-data>
    <vl-properties-label v-if="!(isCodeList || isTable)">{{ $t('deliveryentity.detail.crs') }}</vl-properties-label>
    <vl-properties-data v-if="!(isCodeList || isTable)">{{ detail.crs.name }}</vl-properties-data>
    <vl-properties-label v-if="isCodeList">{{ $t('deliveryentity.detail.dataConnection') }}</vl-properties-label>
    <vl-properties-data v-if="isCodeList"> {{ props.detail.dataConnection?.label ?? '/' }}</vl-properties-data>
    <vl-properties-label v-if="isCodeList">{{ $t('deliveryentity.detail.schema') }}</vl-properties-label>
    <vl-properties-data v-if="isCodeList">{{ props.detail.schema ?? '/' }}</vl-properties-data>
  </vl-properties-list>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { DeliveryEntityDetailDto } from '@/api/backoffice/clients';
import PbsEntityRouterLink from '@/components/PbsEntityRouterLink.vue';
import { ENUM_EntityTypes } from '@/modules/configuration/common';

const props = defineProps<{
  detail: DeliveryEntityDetailDto;
}>();

const detail = computed((): DeliveryEntityDetailDto => {
  return props.detail;
});

const isTable = computed((): boolean => {
  return detail.value?.model?.entityTypeName == ENUM_EntityTypes.Table.name;
});

const isCodeList = computed((): boolean => {
  return detail.value?.model?.entityTypeName == ENUM_EntityTypes.CodeList.name;
});
</script>
